// @flow
import * as React from 'react';
import { Box, Container, Heading } from 'gestalt';

type Props = {|
  children: React.Node,
|};

const ProfileEmptyState = ({ children }: Props) => (
  <Container>
    <Box paddingY={5}>
      <Heading color="gray" size="xs">
        {children}
      </Heading>
    </Box>
  </Container>
);

export default ProfileEmptyState;
